/* global google */
import CancoMarkerSmall from "../../../assets/cancoMarkerSmall.png";

/** Raw asset URL before `google.maps` is ready (prevents blank marker on first paint). */
export const ALL_LOCATIONS_MARKER_IMAGE_URL = CancoMarkerSmall;

const SCALED_W = 32;
const SCALED_H = 40;

/**
 * Scaled store pin for the All Locations map only (Find Location `Map` uses the raw asset).
 */
export function getAllLocationsStoreMarkerIcon() {
  if (typeof google === "undefined" || !google?.maps) {
    return ALL_LOCATIONS_MARKER_IMAGE_URL;
  }
  return {
    url: CancoMarkerSmall,
    scaledSize: new google.maps.Size(SCALED_W, SCALED_H),
    anchor: new google.maps.Point(SCALED_W / 2, SCALED_H),
  };
}
